/**
 * Created by hp on 2017/6/26.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';

import ChannelManagerBottom from './ChannelManagerBottom';
import ChannelStudentBottom from './ChannelStudentBottom';

import '../../styles/channel/ChannelBottomNav.css';

class ChannelBottomNav extends Component {
    render() {
        const {role} = this.props;
        return (
            <div className="channel-bottom-nav bottom-fixed">
                {role.is_manager ?
                    <ChannelManagerBottom />
                    :
                    <ChannelStudentBottom />
                }
            </div>
        )
    }
}

export default connect((state) => ({
    role: state.channel.role,
}))(ChannelBottomNav)


// WEBPACK FOOTER //
// ./src/components/channel/ChannelBottomNav.js